import { Activity } from "lucide-react";
import type { DashboardTarget } from "@/lib/api/dashboard";
import { useDashboardWidget } from "@/lib/hooks/use-dashboard";
import { useT } from "@/lib/i18n/use-t";
import { useDashboardFormat } from "../use-dashboard-format";
import { T } from "./activities-widget.i18n";
import { KeyFigureValue } from "./key-figure-value";
import { StatsCard } from "./stats-card";

export function ActivitiesWidget({ target }: { target: DashboardTarget }) {
  const { data, isLoading, error } = useDashboardWidget("activities", target);
  const t = useT(T);
  const { count } = useDashboardFormat();
  return (
    <StatsCard
      icon={Activity}
      label={t.activitiesThisMonth}
      value={
        <KeyFigureValue isLoading={isLoading} error={error}>
          {data && count(data.total)}
        </KeyFigureValue>
      }
      subtitle={t.activitiesSubtitle}
    />
  );
}
